import { styled } from '@mui/material';
import { Grid, Typography } from '@kc-console/common-ui';

import type { DetailViewSubSectionProps } from './types';

/**
 * [ DetailViewSubSectionContainer의 props.subSections로 주어진 서브 섹션 배열을 랜더링하는 컴포넌트 ]
 *
 * - DetailViewSubSectionContainer에서 주어진 subSections 배열의 각 아이템을 랜더링하는 컴포넌트입니다.
 * - 서비스 개발 시 직접 사용되지 않으며 DetailViewSubSectionContainer에서 내부에서 사용됩니다.
 * - DetailViewSubSection은 DetailViewSection과 달리, header 그리고 headerAction 모두 없을 경우 랜더링하지 않습니다. (optional 허용)
 */
const DetailViewSubSection = ({
  header,
  description,
  content,
  headerAction,
  depth,
}: DetailViewSubSectionProps) => {
  const shouldDisplayHeader = header ?? headerAction;
  return (
    <StyledWrapper>
      {shouldDisplayHeader && (
        <StyledHeaderWrapper>
          <Grid container alignItems={'center'} justifyContent={'space-between'}>
            {header && (
              <StyledHeader variant={depth === 2 ? 'label/semibold/lg' : 'label/semibold/md'}>
                {header}
              </StyledHeader>
            )}
            {headerAction && <StyledHeaderAction>{headerAction}</StyledHeaderAction>}
          </Grid>
          {description && (
            <StyledDescription variant={'label/regular/sm'} color={'text/weaker/default'}>
              {description}
            </StyledDescription>
          )}
        </StyledHeaderWrapper>
      )}
      <StyledContent>{content}</StyledContent>
    </StyledWrapper>
  );
};

const StyledWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledHeaderWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`;

const StyledHeaderAction = styled('div')``;

const StyledHeader = styled(Typography)`
  display: flex;
`;

const StyledDescription = styled(Typography)`
  display: flex;
`;

const StyledContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default DetailViewSubSection;
